// extracted by mini-css-extract-plugin
export default {"formContainer":"form_formContainer__74Pwx"};